import { render, staticRenderFns } from "./aFeeDetailDiscount.vue?vue&type=template&id=90918a76&scoped=true"
import script from "./aFeeDetailDiscount.vue?vue&type=script&lang=js"
export * from "./aFeeDetailDiscount.vue?vue&type=script&lang=js"
import style0 from "./aFeeDetailDiscount.vue?vue&type=style&index=0&id=90918a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90918a76",
  null
  
)

export default component.exports